import http from './http'
const login  = function(data) {
    return http.post('./modules/User/UserRouter.php?c=auth', data)
}
export default login


// WEBPACK FOOTER //
// ./src/js/services/auth.js